export default [
  {
    label: 'メールアドレス',
    key: 'email',
  },
  {
    label: 'ユーザ名',
    key: 'search_username',
  },
]
